import { Injectable } from '@angular/core';
import { ColumnShown } from '@app/library/models/column-shown.model';
import { ColumnsStateModel } from '@app/library/states/columns.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import {
  SetMobilePlaylistColumns,
  TogglePlaylistColumn,
} from './playlist-columns.actions';

export interface PlaylistColumnsStateModel {
  album: boolean;
  duration: boolean;
  addedDate: boolean;
  bpm: boolean;
  kbps: boolean;
  tags: boolean;
  playlists: boolean;
  year: boolean;
  edited: boolean;
}

@State<PlaylistColumnsStateModel>({
  name: 'playlistColumns',
  defaults: {
    album: true,
    duration: true,
    addedDate: true,
    bpm: false,
    kbps: false,
    tags: true,
    playlists: false,
    edited: false,
    year: false,
  },
})
@Injectable()
export class PlaylistColumnsState {
  @Selector()
  static getColumnShow(state: PlaylistColumnsStateModel): ColumnShown {
    return {
      album: state.album,
      duration: state.duration,
      addedDate: state.addedDate,
      bpm: state.bpm,
      kbps: state.kbps,
      tags: state.tags,
      playlists: state.playlists,
      year: state.year,
    };
  }

  @Action(TogglePlaylistColumn)
  toggleColumn(
    ctx: StateContext<PlaylistColumnsStateModel>,
    { column }: TogglePlaylistColumn,
  ) {
    const old = ctx.getState()[column];
    ctx.patchState({
      [column]: !old,
      edited: true,
    });
  }

  @Action(SetMobilePlaylistColumns)
  setMobileColumns(ctx: StateContext<ColumnsStateModel>) {
    if (!ctx.getState().edited) {
      ctx.patchState({
        album: false,
        duration: true,
        addedDate: true,
        bpm: false,
        kbps: false,
        tags: false,
        playlists: false,
        edited: true,
        year: false,
      });
    }
  }
}
